export default function createTemplate(templateMarkup) {
    const template = document.createElement("template");
    template.innerHTML = templateMarkup;
    return {
        template,
        getElement() {
            return template.content.cloneNode(true).firstElementChild;
        },
    };
}
